// src/App.js
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoadingScreen from "./components/LoadingScreen";
import React, { useState, useEffect } from "react";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import HtmlCourse from "./pages/HtmlCourse";
import HtmlQuiz from "./pages/HtmlQuiz";
import CssCourse from "./pages/CssCourse";
import CssQuiz from "./pages/CssQuiz";
import JsCourse from "./pages/JsCourse";
import JsBasicsCourse from "./pages/JsBasicsCourse";
import JsQuiz from "./pages/JsQuiz";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import LanguageSelector from "./components/LanguageSelector";
import HtmlBasicsCourse from "./pages/HtmlBasicsCourse";
import ThemeToggle from "./components/ThemeToggle";
import "./App.css";
import AdminPanel from "./pages/AdminPanel";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
// import Sidebar from './components/Sidebar';
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import CssBasicsCourse from "./pages/CssBasicsCourse";
import ChangePassword from "./pages/ChangePassword";
import ProtectedRoute from "./components/ProtectedRoute";
import CrazyCookieConsent from "./components/CrazyCookieConsent";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Show the loading screen for 2 seconds

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <LanguageProvider>
      <ThemeProvider>
        <Router>
          <div className="App">
            <ThemeToggle />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              <Route path="/courses/html" element={<HtmlCourse />} />
              <Route path="/courses/html/quiz" element={<HtmlQuiz />} />
              <Route
                path="/html-course/:topic"
                element={<HtmlBasicsCourse />}
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }/>

              <Route path="/courses/css" element={<CssCourse />} />
              <Route path="/css-course/:topic" element={<CssBasicsCourse />} />

              <Route path="/courses/css/quiz" element={<CssQuiz />} />
              <Route path="/courses/javascript" element={<JsCourse />} />
              <Route path="/js-course/:topic" element={<JsBasicsCourse />} />

              <Route path="/courses/js/quiz" element={<JsQuiz />} />
              <Route path="/admin" element={<AdminPanel />} />

              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="change-password" element={<ChangePassword />} />

              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <CrazyCookieConsent/>
          </div>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
